var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:(`width: 100% !important; height: 100% !important; overflow: auto ${_vm.contentStyle}`)},[(_vm.widget?.title !== undefined && _vm.widget?.title !== '')?_c('v-toolbar',{style:(_vm.titleStyle),attrs:{"dense":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.widget.title))])],1):_vm._e(),(
      !_vm.getMetaValueAsBool(_vm.metaKeys.IGNORE_BODY) &&
      _vm.widget?.content !== undefined
    )?_c('v-card-text',[_c('div',{style:(_vm.contentStyle),domProps:{"innerHTML":_vm._s(_vm.widget?.content)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }